/**
 * Changes this tab just made itself (T11-52): change messages carry no "who" (no PII on the wire),
 * so a toast such as "money received" would also pop up for the person who pressed 入金確認. The
 * screen notes what it changed (`order:<id>`) right before the call; the alert rules skip messages
 * about it for a short while.
 */
const OWN_WINDOW_MS = 15_000;
const own = new Map<string, number>();

export function noteOwnChange(key: string, now: number = Date.now()): void {
  own.set(key, now);
  for (const [k, at] of own) {
    if (now - at > OWN_WINDOW_MS) {
      own.delete(k);
    }
  }
}

export function isOwnChange(key: string | null | undefined, now: number = Date.now()): boolean {
  if (!key) {
    return false;
  }
  const at = own.get(key);
  return at !== undefined && now - at <= OWN_WINDOW_MS;
}

/** Tests. */
export function resetOwnChanges(): void {
  own.clear();
}
